import { inject, injectable } from 'tsyringe';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { IAnalyticsGatewayToken, type IAnalyticsGateway } from '@/shared/analytics/AnalyticsGateway';
import type { ConversationTurn } from '@/shared/analytics/AnalyticsTypes';

/**
 * Loads a single session's conversation transcript for the L2 chat viewer.
 * Caches by session id so reselecting turns within the same session does not refetch.
 */
@injectable()
export class ConversationViewModel extends BaseViewModel {
    turns: ConversationTurn[] = [];
    loading = false;
    errorMessage: string | null = null;
    private loadedSessionId: string | null = null;

    constructor(@inject(IAnalyticsGatewayToken) private gateway: IAnalyticsGateway) {
        super();
    }

    async load(sessionId: string): Promise<void> {
        if (sessionId === this.loadedSessionId && this.errorMessage === null) return;
        this.loadedSessionId = sessionId;
        this.turns = [];
        this.loading = true;
        this.errorMessage = null;
        this.notifyChange();
        try {
            this.turns = await this.gateway.getSessionConversation(sessionId);
        } catch (err) {
            this.errorMessage = err instanceof Error ? err.message : String(err);
        } finally {
            this.loading = false;
            this.notifyChange();
        }
    }
}
